<div class="input-fields">
  <div>
    <label (click)="show.Q = !show.Q"
           [ngClass]="[show.Q? 'active' : '']"
           class="colapsable">Item Q</label>
    <div [ngClass]="[show.Q? 'active' : '']" class="colapsable">
      <div>
        <label for="acc_notam_firs">FIR</label>
        <input [(ngModel)]="notam.itemQ.fir" id="acc_notam_firs" name="acc_notam_firs" required
               type="text"/>
      </div>

      <div>
        <label for="acc_notam_code">Notam Code</label>
        <ng-container *ngIf="notamType == NotamType.NEW">
          <select [(ngModel)]="notam.itemQ.notam_code" id="acc_notam_code" name="acc_notam_code" required
                  type="text">
            <option title="Wider Area" value="QGWAU">QGWAU</option>
            <option title="Only Aerodrome" value="QGAAU">QGAAU</option>
            <option title="Danger Area" value="QRDCA">QRDCA</option>
            <option title="Restricted Area" value="QRTCA">QRTCA</option>
          </select>
        </ng-container>
        <ng-container *ngIf="notamType == NotamType.CANCELLATION">
          <select [(ngModel)]="notam.itemQ.notam_code" id="acc_notam_code" name="acc_notam_code" required
                  (ngModelChange)="notam.itemE.area = notam.decodeNotamCode()"
                  type="text">
            <option title="Resumed normal operations"
                    [value]="notam.itemQ.notam_code.substring(0, 3) + 'AK'">{{notam.itemQ.notam_code.substring(0, 3) + 'AK'}}</option>
            <option title="Operative (or reoperative) subject to previously published limitations/conditions"
                    [value]="notam.itemQ.notam_code.substring(0, 3) + 'AL'">{{notam.itemQ.notam_code.substring(0, 3) + 'AL'}}</option>
            <option title="Operational"
                    [value]="notam.itemQ.notam_code.substring(0, 3) + 'AO'">{{notam.itemQ.notam_code.substring(0, 3) + 'AO'}}</option>
            <option title="Completed"
                    [value]="notam.itemQ.notam_code.substring(0, 3) + 'CC'">{{notam.itemQ.notam_code.substring(0, 3) + 'CC'}}</option>
            <option title="Cancelled"
                    [value]="notam.itemQ.notam_code.substring(0, 3) + 'CN'">{{notam.itemQ.notam_code.substring(0, 3) + 'CN'}}</option>
            <option title="Work completed"
                    [value]="notam.itemQ.notam_code.substring(0, 3) + 'HV'">{{notam.itemQ.notam_code.substring(0, 3) + 'HV'}}</option>
            <option title="Other"
                    [value]="notam.itemQ.notam_code.substring(0, 3) + 'XX'">{{notam.itemQ.notam_code.substring(0, 3) + 'XX'}}</option>
          </select>
        </ng-container>
      </div>

      <div>
        <label for="acc_notam_traffic">Traffic</label>
        <input [(ngModel)]="notam.itemQ.traffic" id="acc_notam_traffic" name="acc_notam_traffic" required
               type="text"/>
      </div>

      <div>
        <label for="acc_notam_purpose">Purpose</label>
        <input [(ngModel)]="notam.itemQ.purpose" id="acc_notam_purpose" name="acc_notam_purpose" required
               type="text"/>
      </div>

      <div>
        <label for="acc_notam_scope">Scope</label>
        <select [(ngModel)]="notam.itemQ.scope" id="acc_notam_scope" name="acc_notam_scope" required
                type="text">
          <option title="Only Aerodrome" value="A">A</option>
          <option title="Only En-Route Traffic" value="E">E</option>
          <option title="Aerodrome and En-Route Traffic" value="AE">AE</option>
        </select>
      </div>

      <div>
        <label for="acc_notam_fl_lower">Lower</label>
        <input [(ngModel)]="notam.itemQ.fl.lower" id="acc_notam_fl_lower" name="acc_notam_fl_lower" required
               (ngModelChange)="notam.updateArea()"
               type="text"/>
        <span>[FL]</span>
      </div>

      <div>
        <label for="acc_notam_fl_upper">Upper</label>
        <input [(ngModel)]="notam.itemQ.fl.upper" id="acc_notam_fl_upper" name="acc_notam_fl_upper" required
               (ngModelChange)="notam.updateArea()"
               type="text"/>
        <span>[FL]</span>
      </div>

      <div>
        <label for="fl_buffer">Buffer</label>
        <input [(ngModel)]="notam.itemQ.fl.buffer" id="fl_buffer" name="fl_buffer" required
               (ngModelChange)="notam.updateArea()"
               type="text"/>
        <span>[ft]</span>
      </div>

      <div>
        <label for="center_altitude">Center Altitude</label>
        <input [(ngModel)]="notam.entityHeight" id="center_altitude" name="center_altitude" required
               (ngModelChange)="notam.updateArea()"
               type="text"/>
        <span>[ft msl]</span>
      </div>

      <div>
        <label>Center Latitude</label>
        <div class="coordenates">
          <div>
            <select [(ngModel)]="notam.itemQ.center.latitude.cardinal" id="latitude-cardinal" name="lat-cardinal"
                    required
                    style="width: auto;">
              <option value="N">N</option>
              <option value="S">S</option>
            </select>

            <input [(ngModel)]="notam.itemQ.center.latitude.degrees" id="latitude-degrees" name="lat-degrees" required
                   style="width: 16%;"
                   type="number"><span>º</span>
            <input [(ngModel)]="notam.itemQ.center.latitude.minutes" id="latitude-minutes" name="~lat-minutes" required
                   style="width: 16%;"
                   type="number"><span>´</span>
            <input [(ngModel)]="notam.itemQ.center.latitude.seconds" id="latitude-seconds" name="lat-seconds" required
                   style="width: 16%;"
                   type="number"><span>´´</span>
          </div>

          <br/>

          <input [(ngModel)]="notam.itemQ.center.latitude.value" id="latitude-value" name="lat-value" required
                 (ngModelChange)="notam.updateArea()"
                 style="width: 65.5%; margin-top: 5px; margin-bottom: 5px;"
                 type="number">
          <span>º</span>
          <span *ngIf="!notam.itemQ.center.latitude.valid('value')" class="error">
              The Latitude value must be an integer number defined between -90º and 90º.
            </span>
          <span *ngIf="!notam.itemQ.center.latitude.valid('degrees')"
                class="error">
              The Degrees value must be an integer number defined between 0º and 90º.
            </span>
          <span *ngIf="!notam.itemQ.center.latitude.valid('minutes')"
                class="error">
              The Minutes value must be an integer number defined between 0 and 59 minutes.
            </span>
          <span *ngIf="!notam.itemQ.center.latitude.valid('seconds')"
                class="error">
              The Seconds value must be defined between 0 and 59.99.
            </span>
        </div>
      </div>

      <div>
        <label>Center Longitude</label>
        <div class="coordenates">
          <div>
            <select [(ngModel)]="notam.itemQ.center.longitude.cardinal" id="longitude-cardinal" name="lon-cardinal"
                    required
                    style="width: auto;">
              <option value="E">E</option>
              <option value="W">W</option>
            </select>

            <input [(ngModel)]="notam.itemQ.center.longitude.degrees" id="longitude-degrees" name="lon-degrees" required
                   style="width: 16%;"
                   type="number"><span>º</span>
            <input [(ngModel)]="notam.itemQ.center.longitude.minutes" id="longitude-minutes" name="lon-minutes" required
                   style="width: 16%;"
                   type="number"><span>´</span>
            <input [(ngModel)]="notam.itemQ.center.longitude.seconds" id="longitude-seconds" name="lon-seconds" required
                   style="width: 16%;"
                   type="number"><span>´´</span>
          </div>
          <br/>
          <input [(ngModel)]="notam.itemQ.center.longitude.value" id="longitude-value" name="lon-value" required
                 (ngModelChange)="notam.updateArea()"
                 style="width: 65.5%; margin-top: 5px; margin-bottom: 5px;"
                 type="number">
          <span>º</span>
          <span *ngIf="!notam.itemQ.center.longitude.valid('value')"
                class="error">
              The Longitude value must be an integer number defined between -180º and 180º.
            </span>
          <span *ngIf="!notam.itemQ.center.longitude.valid('degrees')"
                class="error">
              The Degrees value must be an integer number defined between 0º and 180º.
            </span>
          <span *ngIf="!notam.itemQ.center.longitude.valid('minutes')"
                class="error">
              The Minutes value must be an integer number defined between 0 and 59 minutes.
            </span>
          <span *ngIf="!notam.itemQ.center.longitude.valid('seconds')"
                class="error">
              The Seconds value must be defined between 0 and 59.99.
            </span>
        </div>
      </div>

      <div>
        <label for="acc_notam_radius">Center Radius</label>
        <input [(ngModel)]="notam.itemQ.radius" id="acc_notam_radius" name="acc_notam_radius" required
               (ngModelChange)="notam.updateArea()"
               type="number"/>
        <span>[NM]</span>
      </div>
    </div>
  </div>

  <div>
    <label for="acc_notam_firs_a">Item A - Location</label>
    <input [(ngModel)]="notam.itemA.firs" id="acc_notam_firs_a" name="acc_notam_firs_a" required
           type="text"/>
  </div>

  <div>
    <label for="acc_notam_start_datetime">Item B - Start of Activity</label>
    <input [(ngModel)]="notam.itemBDate" id="acc_notam_start_datetime" name="acc_notam_start_datetime" required
           type="datetime-local"/>
    <span class="error">
      Please note: The dates you enter are in UTC (Coordinated Universal Time)
    </span>
  </div>

  <div>
    <ng-container *ngIf="notamType == NotamType.NEW">
      <label for="acc_notam_end_datetime">Item C - End of Validity </label>
      <input [(ngModel)]="notam.itemCDate" id="acc_notam_end_datetime" name="acc_notam_end_datetime" required
             type="datetime-local"/>
    </ng-container>
  </div>

  <div>
    <label (click)="show.E = !show.E"
           [ngClass]="[show.E? 'active' : '']"
           class="colapsable">Item E</label>
    <div [ngClass]="[show.E? 'active' : '']" class="colapsable">
      <ng-container *ngIf="notamType == NotamType.NEW">
        <div>
          <label for="acc_notam_intial_text">Initial Text</label>
          <input [(ngModel)]="notam.itemE.initialText" id="acc_notam_intial_text" name="acc_notam_intial_text" required
                 type="text"/>
        </div>

        <div>
          <label for="acc_notam_area">Area</label>
          <textarea [(ngModel)]="notam.itemE.area" id="acc_notam_area"
                    name="acc_notam_area" required style="width: 50%; height: 100px"
                    type="text"></textarea>
        </div>

        <div>
          <label for="acc_notam_area_activation">Area Activation</label>
          <input [(ngModel)]="notam.itemE.areaActivation" id="acc_notam_area_activation" name="acc_notam_area_activation"
                 type="text"/>
        </div>
      </ng-container>
      <ng-container *ngIf="notamType == NotamType.CANCELLATION">
        <div>
          <label for="acc_notam_text">Text</label>
          <textarea [(ngModel)]="notam.itemE.area" id="acc_notam_text"
                    name="acc_notam_text" required style="width: 50%; height: 100px"
                    type="text"></textarea>
        </div>
      </ng-container>

    </div>
  </div>

  <div class="btn" style="border: none">
    <button *ngIf="save != null" (click)="save()">Save</button>
    <button *ngIf="send != null" (click)="send()">Send</button>
    <button *ngIf="reset != null" (click)="reset()">Reset</button>
  </div>
</div>
